import { Counter } from "PFApp/components/counter/counter";
import { CustomValueImportRowsMeta } from "PFCore/services/admin/imports/fetch_custom_value_import_rows";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./import_data_table_page.module.scss";

type ImportDataTableCountersProps = {
  selectedCounter: ImportRowsCounters;
  handleCounterChange: (counter: ImportRowsCounters) => void;
  meta?: CustomValueImportRowsMeta;
};

export enum ImportRowsCounters {
  Total = "total",
  New = "created",
  Duplicate = "duplicated",
  Merged = "merged",
  Blocked = "blocked",
  Error = "failed"
}

type Counter = {
  title: string;
  selected: boolean;
  code: ImportRowsCounters;
  setCounter: (counter: ImportRowsCounters) => void;
  counter: number;
};

export const ImportDataTableCounters = ({
  meta,
  selectedCounter,
  handleCounterChange
}: ImportDataTableCountersProps) => {
  const { t } = useTranslation("skillsManagement", { keyPrefix: "header.modals.import.data.table.counters" });

  const counters = [
    {
      selected: ImportRowsCounters.Total === selectedCounter,
      code: ImportRowsCounters.Total,
      counter: meta?.totalRows
    },
    {
      selected: ImportRowsCounters.New === selectedCounter,
      code: ImportRowsCounters.New,
      counter: meta?.totalCreatedRows
    },
    {
      selected: ImportRowsCounters.Duplicate === selectedCounter,
      code: ImportRowsCounters.Duplicate,
      counter: meta?.totalDuplicatedRows
    },
    {
      selected: ImportRowsCounters.Merged === selectedCounter,
      code: ImportRowsCounters.Merged,
      counter: meta?.totalMergedRows
    },
    {
      selected: ImportRowsCounters.Blocked === selectedCounter,
      code: ImportRowsCounters.Blocked,
      counter: meta?.totalBlockedRows
    },
    {
      selected: ImportRowsCounters.Error === selectedCounter,
      code: ImportRowsCounters.Error,
      counter: meta?.totalFailedRows
    }
  ];

  return (
    <div className={css.counters}>
      {counters.map((counter, index) => (
        <Counter
          title={t(counter.code)}
          {...counter}
          onClick={() => handleCounterChange(counter.code)}
          key={index}
          classes={{ button: css.button }}
        />
      ))}
    </div>
  );
};
